import { Pill } from "@src/appV2/redesign/system/ui-components";

import { getBundleLabel } from "./utils";

interface ShiftBundlePillProps {
  requiredShiftCount: number;
  totalShiftCount: number;
}

export function ShiftBundlePill(props: ShiftBundlePillProps) {
  const { requiredShiftCount, totalShiftCount } = props;

  return (
    <Pill
      size="small"
      variant="filled"
      label={getBundleLabel(requiredShiftCount, totalShiftCount)}
      iconType="block-shift"
      sx={{ width: "fit-content", background: (theme) => theme.palette.shift?.bundle?.gradient }}
    />
  );
}
